export const menu = [
    {
        cat: 'Tablero',
        icon: 'blocks',
        links: [
            {name: 'Dashboard operativo', link: '/dashboard_a'}
        ]
    },
    {
        cat: 'Agenda',
        icon: 'calendar',
        links: [
            {name: 'Agenda', link: '/agenda'},
            {name: 'Propuestas de clientes', link: '/agenda/propuestas'},
            {name: 'Tipos de compromiso', link: '/settings/commitment-types'}
        ]
    },
    {
        cat: 'Pacientes',
        icon: 'users',
        links: [
            {name: 'Pacientes', link: '/patients'},
            {name: 'Medicina ocupacional', link: '/medicina-trabajo'},
            {name: 'Estudios', link: '/studies'}
        ]
    },
    {
        cat: 'Inventario',
        icon: 'blocks',
        links: [
            {name: 'Inventario', link: '/inventory'},
            {name: 'Proveedores', link: '/inventory/suppliers'},
            {name: 'Compras de inventario', link: '/inventory/purchases'},
            {name: 'Tipos de inventario', link: '/settings/inventory-types'}
        ]
    },
    {
        cat: 'Movimientos',
        icon: 'wallet',
        links: [
            {name: 'Ingresos', link: '/movements/incomes'},
            {name: 'Egresos', link: '/movements/expenses'},
            {name: 'Cuentas por cobrar', link: '/movements/receivables'},
            {name: 'Tipos de movimiento', link: '/movements/types'}
        ]
    },
    {
        cat: 'CRM',
        icon: 'users',
        links: [
            {name: 'Prospectos', link: '/crm'},
            {name: 'Empresas', link: '/crm/companies'}
        ]
    },
    {
        cat: 'Configuracion',
        icon: 'settings',
        links: [
            {name: 'Perfiles', link: '/settings/profiles', adminOnly: true},
            {name: 'Portal de empresas', link: '/settings/portal-empresas', adminOnly: true},
            {name: 'Campos de formularios', link: '/settings/formularios', adminOnly: true},
            {name: 'Roles y permisos', link: '/admin/roles', superAdminOnly: true},
            {name: 'Configuracion de perfil', link: '/settings/profile', excludeUserRole: true},
            {name: 'Configuracion de pantalla', link: '/settings/display'}
        ]
    }
];